export const ANALYTICS_CONFIG = {
  clarityTrackingId: 'wm6nfehwth',
} as const;
